import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Please choose your new password below", -1)
const _hoisted_2 = {
  key: 0,
  class: "error-messages"
}
const _hoisted_3 = { class: "field custom-field custom-field_animated" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "custom-field__label-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "custom-field__label" }, "New password")
], -1)
const _hoisted_5 = { class: "button-container" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Back to Login")
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"stick-to-bottom\"><div class=\"row\"><div class=\"col-6 col-md-3 offset-md-3 text-center\"><a href=\"#\">Terms of use</a></div><div class=\"col-6 col-md-3 text-center\"><a href=\"#\">Privacy policy</a></div></div></div>", 1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Your password has been changed", -1)
const _hoisted_9 = { class: "button-container" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Back to Login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", null, [
      _hoisted_1,
      (_ctx.errors)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
              return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("label", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["field__input custom-field__input", _ctx.status(_ctx.$v.password)]),
          type: "password",
          placeholder: " ",
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$v.password.$model) = $event))
        }, null, 2), [
          [_vModelText, _ctx.$v.password.$model]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'login' },
          class: "button button--border"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          href: "#",
          class: "button button--orange",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
        }, "Reset password")
      ]),
      _hoisted_7
    ], 512), [
      [_vShow, !_ctx.passwordReset]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: { name: 'login' },
          class: "button button--border"
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, _ctx.passwordReset]
    ])
  ]))
}